export default class AnchorList {
    constructor() {
        this.links = document.querySelectorAll('.nav-link');
        this.sections = [];
        this.offset = 120; // altura do header fixo

        if (this.links.length > 0) {
            this.init();
        }
    }

    init() {
        this.mapSections();
        this.bindClickEvents();
        this.observeSections();
    }

    mapSections() {
        this.sections = Array.from(this.links)
            .map(link => {
                const selector = link.getAttribute('href');
                if (selector && selector.startsWith('#')) {
                    const section = document.querySelector(selector);
                    if (section) {
                        return { link, section };
                    }
                }
                return null;
            })
            .filter(item => item !== null);
    }

    bindClickEvents() {
        this.links.forEach(link => {
            link.addEventListener('click', () => this.setActive(link));
        });
    }

    observeSections() {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const current = this.sections.find(
                            item => item.section === entry.target
                        );
                        if (current) {
                            this.setActive(current.link);
                        }
                    }
                });
            },
            {
                rootMargin: `-${this.offset}px 0px -60% 0px`, 
                threshold: 0.1
            }
        );

        this.sections.forEach(({ section }) => observer.observe(section));
    }

    setActive(link) {
        this.links.forEach(l => l.classList.remove('active'));
        link.classList.add('active');
    }
}

// inicialização automática
if (document.querySelector('.nav-link')) {
    new AnchorList();
}
